// import React, { useState, useEffect } from 'react';
// import {
// 	Box,
// 	Paper,
// 	Chip,
// 	useTheme,
// 	Table,
// 	TableHead,
// 	TableRow,
// 	TableCell,
// 	TableBody,
// 	TableContainer,
// 	Grid2,
// 	useMediaQuery,
// 	Link,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';
// import MyHeadings from '../Vendor-ui/Headings';
// import MySearchInputs from '../Vendor-ui/SearchInputs';
// import { VendorApprovedsingle, VendorRequest } from '../../../../services/api/vendor';
// import { MyModal } from '../Vendor-ui/Modal';

// const rowVariants = {
// 	hidden: { opacity: 0, y: 10 },
// 	visible: (i: number) => ({
// 		opacity: 1,
// 		y: 0,
// 		transition: { delay: i * 0.1 },
// 	}),
// };

// export default function VendorRequestsTable() {
// 	const theme = useTheme();
// 	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// 	const navigate = useNavigate();
// 	const [loader, setLoader] = useState(false);
// 	const [requests, setRequests] = useState<any[]>([]);
// 	const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
// 	const [searchTerm, setSearchTerm] = useState('');
// 	// const [selectedIds, setSelectedIds] = useState<string[]>([]);
// 	const [openDialog, setOpenDialog] = useState(false);
// 	const [currentAction, setCurrentAction] = useState<{
// 		id?: string;
// 		action?: 'approve' | 'reject';
// 	} | null>(null);
// 	const [actionModal, setActionModal] = useState<any>(null);

// 	const fetchRequestVendor = async () => {
// 		try {
// 			const response = await VendorRequest();
// 			if (response.success && response.data?.vendors?.length) {
// 				const mappedRequests = response.data.vendors.map((v: any) => ({
// 					id: v.vendorId || v._id,
// 					company: v.companyName || '',
// 					contactPerson: v.ownerName || '',
// 					contactEmail: v.email || '',
// 					phone: v.mobile || '',
// 					businessType: v.companyType || '',
// 					submitted: new Date(v.createdAt).toLocaleDateString('en-GB'),
// 					rawDate: new Date(v.createdAt),
// 					_id: v._id,
// 				}));
// 				setRequests(mappedRequests);
// 			} else {
// 				setRequests([]);
// 			}
// 		} catch (error) {
// 			console.error('Error fetching vendor requests:', error);
// 			setRequests([]);
// 		}
// 	};

// 	useEffect(() => {
// 		fetchRequestVendor();
// 	}, []);

// 	useEffect(() => {
// 		let result = [...requests];
// 		if (searchTerm) {
// 			const term = searchTerm.toLowerCase();
// 			result = result.filter(
// 				(req) =>
// 					req.company.toLowerCase().includes(term) ||
// 					req.contactPerson.toLowerCase().includes(term) ||
// 					req.contactEmail.toLowerCase().includes(term) ||
// 					req.phone.toLowerCase().includes(term) ||
// 					req.businessType.toLowerCase().includes(term) ||
// 					req.id.toLowerCase().includes(term)
// 			);
// 		}
// 		setFilteredRequests(result);
// 		// setSelectedIds((prev) => prev.filter((id) => result.some((r) => r.id === id)));
// 	}, [searchTerm, requests]);

// 	const handleActionClick = async (id: string, action: 'approve' | 'reject') => {
// 		setCurrentAction({ id, action });
// 		setActionModal(action);
// 		setOpenDialog(true);

// 		try {
// 			setLoader(true);
// 			let response;

// 			// rejected → update vendor status
// 			const payload = {
// 				...requests,
// 				status: 'Rejected',
// 				reason, // ✅ optional reason captured from modal
// 			};
// 			response = await VendorApprovedsingle(id, payload);

// 			console.log(response);
// 			if (response?.success) {
// 				setSnackbarAction('approve');
// 				setSnackbarMessage(response?.data?.message);
// 				setSnackbarOpen(true);
// 				fetchData();
// 				window.location.href = '/vendor/approved';
// 			} else {
// 				setSnackbarAction('reject');
// 				setSnackbarMessage(response?.data?.errors || 'Failed to update.');
// 				setSnackbarOpen(true);
// 			}
// 		} catch (error) {
// 			console.error(`Error updating vendor status:`, error);
// 			setSnackbarAction(action);
// 			setSnackbarMessage('Something went wrong.');
// 			setSnackbarOpen(true);
// 		} finally {
// 			setUpdating(false);
// 			setModalOpen(false);
// 			setLoader(false);
// 		}
// 	};

// 	const handleConfirmAction = () => {
// 		if (!currentAction) return;
// 		setRequests((prev) => prev.filter((req) => req.id !== currentAction.id));
// 		setOpenDialog(false);
// 		setCurrentAction(null);
// 		setLoader(true);

// 		// setSelectedIds((prev) => prev.filter((id) => id !== currentAction.id));
// 	};

// 	const handleCancelAction = () => {
// 		setOpenDialog(false);
// 		setCurrentAction(null);
// 	};

// 	// const handleCheckboxChange = (id: string) => {
// 	// 	setSelectedIds((prev) =>
// 	// 		prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
// 	// 	);
// 	// };

// 	return (
// 		<Box sx={{ width: '100%', fontFamily: "'Poppins', sans-serif" }}>
// 			<MyHeadings Title="Vendor Requests" subtitle="Manage your Requests vendor partners" />

// 			{/* Top Controls */}
// 			<Box sx={{ py: 2 }}>
// 				<Grid2 container spacing={2}>
// 					<Grid2 size={{ xs: 12, sm: 6 }}>
// 						<MySearchInputs searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
// 					</Grid2>
// 				</Grid2>
// 			</Box>

// 			<Paper variant="outlined" sx={{ borderColor: theme.palette.grey[300] }}>
// 				<TableContainer sx={{ maxHeight: isMobile ? 400 : 'auto' }}>
// 					<Table stickyHeader>
// 						<TableHead>
// 							<TableRow>
// 								<TableCell>Request ID</TableCell>
// 								<TableCell>Company</TableCell>
// 								{!isMobile && <TableCell>Contact Person</TableCell>}
// 								<TableCell>Email</TableCell>
// 								{!isMobile && <TableCell>Phone</TableCell>}
// 								<TableCell>Submitted</TableCell>
// 								<TableCell>Actions</TableCell>
// 							</TableRow>
// 						</TableHead>
// 						<TableBody>
// 							{filteredRequests.length > 0 ? (
// 								filteredRequests.map((req, i) => (
// 									<motion.tr
// 										key={req.id}
// 										custom={i}
// 										initial="hidden"
// 										animate="visible"
// 										variants={rowVariants}
// 									>
// 										<TableCell>
// 											<Link
// 												href={`/vendor/request/${req._id}`}
// 												underline="hover"
// 											>
// 												{req.id}
// 											</Link>
// 										</TableCell>
// 										<TableCell>{req.company}</TableCell>
// 										{!isMobile && <TableCell>{req.contactPerson}</TableCell>}
// 										<TableCell>{req.contactEmail}</TableCell>
// 										{!isMobile && <TableCell>{req.phone}</TableCell>}
// 										<TableCell>{req.submitted}</TableCell>
// 										<TableCell>
// 											<Chip
// 												label="Approve"
// 												size="small"
// 												onClick={() =>
// 													navigate(`/vendor/request/${req._id}`)
// 												}
// 												sx={{
// 													bgcolor: '#6EE7B7',
// 													color: '#065F46',
// 													fontWeight: 500,
// 													mr: 1,
// 													cursor: 'pointer',
// 													'&:hover': {
// 														bgcolor: 'success.main',
// 														color: 'white',
// 													},
// 												}}
// 											/>
// 											<Chip
// 												label="Reject"
// 												size="small"
// 												onClick={() => handleActionClick(req.id, 'reject')}
// 												sx={{
// 													bgcolor: '#F9A8D4',
// 													color: '#9D174D',
// 													fontWeight: 500,
// 													cursor: 'pointer',
// 													'&:hover': {
// 														bgcolor: 'error.main',
// 														color: 'white',
// 													},
// 												}}
// 											/>
// 										</TableCell>
// 									</motion.tr>
// 								))
// 							) : (
// 								<TableRow>
// 									<TableCell colSpan={6} align="center">
// 										No requests found
// 									</TableCell>
// 								</TableRow>
// 							)}
// 						</TableBody>
// 					</Table>
// 				</TableContainer>
// 			</Paper>

// 			<MyModal
// 				loader={loader}
// 				open={openDialog}
// 				action={actionModal}
// 				onClose={() => setOpenDialog(false)}
// 				onConfirm={(reason?: string) => handleConfirmAction(modalAction!, reason)}
// 			/>
// 		</Box>
// 	);
// }

import React, { useState, useEffect } from 'react';
import {
	Box,
	Paper,
	Chip,
	useTheme,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TableContainer,
	Grid2,
	useMediaQuery,
	Link,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import MyHeadings from '../Vendor-ui/Headings';
import MySearchInputs from '../Vendor-ui/SearchInputs';
import { VendorApprovedsingle, VendorRequest } from '../../../../services/api/vendor';
import { MyModal } from '../Vendor-ui/Modal';
import MySnackbarModal from '../Vendor-ui/SnackbarModal';

const rowVariants = {
	hidden: { opacity: 0, y: 10 },
	visible: (i: number) => ({
		opacity: 1,
		y: 0,
		transition: { delay: i * 0.1 },
	}),
};

interface ActionState {
	id: string;
	action: 'approve' | 'reject';
}

export default function VendorRequestsTable() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const navigate = useNavigate();

	const [loader, setLoader] = useState(false);
	const [requests, setRequests] = useState<any[]>([]);
	const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
	const [searchTerm, setSearchTerm] = useState('');

	// Snackbar states
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [snackbarAction, setSnackbarAction] = useState<'approve' | 'reject' | null>(null);
	const [loading, setLoading] = useState(false);

	const [openDialog, setOpenDialog] = useState(false);
	const [currentAction, setCurrentAction] = useState<ActionState | null>(null);
	const [actionModal, setActionModal] = useState<'approve' | 'reject' | null>(null);

	// Fetch vendor requests
	const fetchRequestVendor = async () => {
		try {
			const response = await VendorRequest();
			if (response.success && response.data?.vendors?.length) {
				const mappedRequests = response.data.vendors.map((v: any) => ({
					id: v.vendorId || v._id,
					company: v.companyName || '',
					contactPerson: v.ownerName || '',
					contactEmail: v.email || '',
					phone: v.mobile || '',
					businessType: v.companyType || '',
					submitted: new Date(v.createdAt).toLocaleDateString('en-GB'),
					rawDate: new Date(v.createdAt),
					_id: v._id,
					approvelStatus: v.approvelStatus,
				}));
				setRequests(mappedRequests);
			} else {
				setRequests([]);
			}
		} catch (error) {
			console.error('Error fetching vendor requests:', error);
			setRequests([]);
		}
	};

	useEffect(() => {
		fetchRequestVendor();
	}, []);

	useEffect(() => {
		let result = [...requests];
		if (searchTerm) {
			const term = searchTerm.toLowerCase();
			result = result.filter(
				(req) =>
					req.company.toLowerCase().includes(term) ||
					req.contactPerson.toLowerCase().includes(term) ||
					req.contactEmail.toLowerCase().includes(term) ||
					req.phone.toLowerCase().includes(term) ||
					req.businessType.toLowerCase().includes(term) ||
					req.id.toLowerCase().includes(term)
			);
		}
		setFilteredRequests(result);
	}, [searchTerm, requests]);

	// Open modal for approve/reject
	const handleActionClick = (id: string, action: 'approve' | 'reject') => {
		setCurrentAction({ id, action });
		setActionModal(action);
		setOpenDialog(true);
	};

	// Confirm action from modal
	const handleConfirmAction = async (reason?: string) => {
		if (!currentAction) return;
		setLoader(true);
		setLoading(true);

		try {
			const payload = {
				status: currentAction.action === 'approve' ? 'Approved' : 'Rejected',
				reason: reason || '',
			};
			const response = await VendorApprovedsingle(currentAction.id, payload);
			console.log(response, 'response');
			if (response?.success) {
				setRequests((prev) => prev.filter((req) => req.id !== currentAction.id));
				setSnackbarAction(currentAction.action);
				setSnackbarMessage(response?.data?.message || 'Action successful.');
				setSnackbarOpen(true);
			} else {
				setSnackbarAction(currentAction.action);
				setSnackbarMessage(response?.errors || 'Failed to update vendor status.');
				setSnackbarOpen(true);
			}
		} catch (error) {
			console.error('Error updating vendor status:', error);
			setSnackbarAction(currentAction.action);
			setSnackbarMessage('Something went wrong.');
			setSnackbarOpen(true);
		} finally {
			setLoader(false);
			setOpenDialog(false);
			setCurrentAction(null);
			setActionModal(null);
			setLoading(false);
		}
	};

	const handleCancelAction = () => {
		setOpenDialog(false);
		setCurrentAction(null);
		setActionModal(null);
	};

	return (
		<Box sx={{ width: '100%', fontFamily: "'Poppins', sans-serif" }}>
			<MyHeadings Title="Vendor Requests" subtitle="Manage your Requests vendor partners" />

			{/* Top Controls */}
			<Box sx={{ py: 2 }}>
				<Grid2 container spacing={2}>
					<Grid2 size={{ xs: 12, sm: 6 }}>
						<MySearchInputs searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
					</Grid2>
				</Grid2>
			</Box>

			<Paper variant="outlined" sx={{ borderColor: theme.palette.grey[300] }}>
				<TableContainer sx={{ maxHeight: isMobile ? 400 : 'auto' }}>
					<Table stickyHeader>
						<TableHead>
							<TableRow>
								<TableCell>Request ID</TableCell>
								<TableCell>Company</TableCell>
								{!isMobile && <TableCell>Contact Person</TableCell>}
								<TableCell>Email</TableCell>
								{!isMobile && <TableCell>Phone</TableCell>}
								<TableCell>Submitted</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{filteredRequests.length > 0 ? (
								filteredRequests.map((req?: any, i?: number) => (
									<motion.tr
										key={req.id}
										custom={i}
										initial="hidden"
										animate="visible"
										variants={rowVariants}
									>
										<TableCell>
											<Link
												href={`/vendor/request/${req._id}`}
												underline="hover"
											>
												{req.id}
											</Link>
										</TableCell>
										<TableCell>{req.company}</TableCell>
										{!isMobile && <TableCell>{req.contactPerson}</TableCell>}
										<TableCell>{req.contactEmail}</TableCell>
										{!isMobile && <TableCell>{req.phone}</TableCell>}
										<TableCell>{req.submitted}</TableCell>
										<TableCell>
											<Chip
												label={req?.approvelStatus}
												size="small"
												// onClick={() => handleActionClick(req.id, 'approve')}
												sx={{
													bgcolor:
														(req?.approvelStatus as any) === 'Rejected'
															? '#eb1313ff'
															: 'success.main',
													color: '#ffffffff',
													fontWeight: 500,
													mr: 1,
												}}
											/>
										</TableCell>
										<TableCell>
											<Chip
												label="Approve"
												size="small"
												onClick={() =>
													navigate(`/vendor/request/${req._id}`)
												}
												sx={{
													bgcolor: '#6EE7B7',
													color: '#065F46',
													fontWeight: 500,
													mr: 1,
													cursor: 'pointer',
													'&:hover': {
														bgcolor: 'success.main',
														color: 'white',
													},
												}}
											/>
											{(!req?.approvelStatus as any) === 'Rejected' && (
												<Chip
													label="Reject"
													size="small"
													onClick={() =>
														handleActionClick(req.id, 'reject')
													}
													sx={{
														bgcolor: '#F9A8D4',
														color: '#9D174D',
														fontWeight: 500,
														cursor: 'pointer',
														'&:hover': {
															bgcolor: 'error.main',
															color: 'white',
														},
													}}
												/>
											)}
										</TableCell>
									</motion.tr>
								))
							) : (
								<TableRow>
									<TableCell colSpan={6} align="center">
										No requests found
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>

			{/* Modal for approve/reject */}
			<MyModal
				loader={loader}
				open={openDialog}
				action={actionModal}
				onClose={handleCancelAction}
				onConfirm={(reason?: string) => handleConfirmAction(reason)}
			/>

			{/* Snackbar for success/error messages */}
			<MySnackbarModal
				open={snackbarOpen}
				action={snackbarAction}
				Message={snackbarMessage}
				onClose={() => setSnackbarOpen(false)}
				loading={loading}
			/>
		</Box>
	);
}
